import {
  Directive,
  HostListener,
  output,
  OutputEmitterRef,
} from '@angular/core';

@Directive({
  selector: '[awHoverHighlight]',
})
export class HoverHighlight {
  // @TODO discuss with team if handing in styling as Inputs is better
  /*
   * basically make input signals for style objects
   * get elementref
   * onhover change attach these objects to the elementref
   * */
  public readonly onHover: OutputEmitterRef<boolean> = output();

  @HostListener('mouseover')
  onMouseOver() {
    this.onHover.emit(true);
  }
  @HostListener('mouseout')
  onMouseOut() {
    this.onHover.emit(false);
  }
}
